module.exports = __webpack_public_path__ + "img/b1-m.a9c98be.png";